import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import techConfig from '../../../techConfig';
import * as Constant from '../../../constants/actionTypes';
import { labelName } from '../../UtilsWeb';
import styles from './styles';

const FooterText = props => {
  const { classes } = props;
  return (
    <div className={classes.bottomFooter} role="contentinfo" id="accessibility-cert-link">
      {techConfig.enableAccessibilityFooterLink && techConfig.accessibilityFooterLink ? (
        <a
          style={{ color: 'inherit', direction: 'initial' }}
          href={techConfig.accessibilityFooterLink}
          target="_blank"
        >
          <p>{labelName(Constant.ACCESSIBILITY_ENABLED)}</p>
        </a>
      ) : (
        <p>{labelName(Constant.ACCESSIBILITY_ENABLED)}</p>
      )}
    </div>
  );
};

FooterText.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FooterText);
